/* eslint-disable camelcase */
/* eslint-disable react/jsx-key */
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Grid, Card,  TableCell, TableRow,Stack, Button, Divider, Container, Typography } from '@mui/material';
import { MotionInView, varFade } from '../../components/animate';
import axios from '../../utils/axios';
import { PATH_DASHBOARD } from '../../routes/paths';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(10, 0),
  backgroundColor: theme.palette.background.neutral,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(15, 0),
  },
}));

// ----------------------------------------------------------------------

export default function Plan() {
     const [mtn, Setmtn] = useState([])
     const [airtel, Setairtel] = useState([])
     const [mobile, Setmobile] = useState([])
     const [glo, Setglo] = useState([])

    useEffect(() => {
        axios.get(`/api/website/plan`).then(data => {
            if(data?.data?.mtn !== undefined){
                Setmtn(data.data?.mtn);
            }
            if(data?.data?.airtel !== undefined){
                Setairtel(data.data?.airtel);
            }
            if(data?.data?.mobile !== undefined){
             Setmobile(data?.data?.mobile)
            }
            if(data?.data?.glo !== undefined){
              Setglo(data?.data?.glo);
            }
        });
      }, []);

  return (
    <RootStyle>
      <Container>
        <Box sx={{ mb: 10, textAlign: 'center' }}>
          <MotionInView variants={varFade().inUp}>
            <Typography component="div" variant="overline" sx={{ mb: 2, color: 'text.disabled' }}>
              pricing plans
            </Typography>
          </MotionInView>
          <MotionInView variants={varFade().inDown}>
            <Typography variant="h2" sx={{ mb: 3 }}>
            Valuable Data Plan And Prices
            </Typography>
          </MotionInView>
        </Box>

        <Grid container spacing={5}>
          
            <Grid key='mtn' item xs={12} md={4}>
              <MotionInView variants={varFade().inDown}>
                <PlanCard plan={mtn} network={'MTN'}/>
              </MotionInView>
            </Grid>

            <Grid key='glo' item xs={12} md={4}>
              <MotionInView variants={varFade().inUp}>
                <PlanCard plan={glo} network={'GLO'}/>
              </MotionInView>
            </Grid>
            <Grid key='mobile' item xs={12} md={4}>
              <MotionInView variants={varFade().inUp}>
                <PlanCard plan={mobile} network={'9MOBILE'}/>
              </MotionInView>
            </Grid>
            <Grid key='airtel' item xs={12} md={4}>
              <MotionInView variants={varFade().inUp}>
                <PlanCard plan={airtel} network={'AIRTEL'}/>
              </MotionInView>
            </Grid>
        </Grid>

        <MotionInView variants={varFade().in}>
          <Box sx={{ p: 5, mt: 10, textAlign: 'center' }}>
            <MotionInView variants={varFade().inDown}>
              <Typography variant="h3">Still have questions?</Typography>
            </MotionInView>

            <MotionInView variants={varFade().inDown}>
              <Typography sx={{ mt: 3, mb: 5, color: 'text.secondary' }}>
                Please describe your case to receive the most accurate advice.
              </Typography>
            </MotionInView>

            <MotionInView variants={varFade().inUp}>
              <Button
                size="large"
                variant="contained"
              >
                Contact us
              </Button>
            </MotionInView>
          </Box>
        </MotionInView>
      </Container>
    </RootStyle>
  );
}

// ----------------------------------------------------------------------

PlanCard.propTypes = {
  plan: PropTypes.object,
  network: PropTypes.string
};

function PlanCard({ plan, network }) {


  return (
    <Card
      sx={{
        p: 5,
        boxShadow: 0,
      }}
    >
      <Stack spacing={5}>
        <div>
          <Typography variant="h4">{network}</Typography>
        </div>
        <Stack spacing={2.5}>
        {plan.map((option) => (
        <TableRow>
    <TableCell> {option?.plan_name}{option?.plan_size} </TableCell>
    <TableCell>₦{option?.smart}</TableCell>
    <TableCell>{option?.plan_day}</TableCell>
  </TableRow>
     ))}

          <Divider sx={{ borderStyle: 'dashed' }} />

        </Stack>

        
        <Button
          size="large"
          fullWidth
          variant={'contained'}
          target="_blank"
          rel="noopener"
          component={RouterLink}
        to={PATH_DASHBOARD.general.buydata}
        >
          Purchase
        </Button>
      </Stack>
    </Card>
  );
}
